export default __webpack_public_path__ + "static/media/attachment-icon.437210e9.svg";